window.ORDER_PAGE_DATA_HELPERS = {
    getTemplatesByServices() {
        if (!this.currServOpt || this.currentCountry != '' || this.currServOpt == 'min' || this.isUserLoggedIn) {
            this.additionalTemplates = ''
            return false
        }

        const serviceName = this.getService(this.currServOpt)
        if (!serviceName || !serviceName.hasOwnProperty('url_service_name')) {
            this.additionalTemplates = ''
            return false
        }

        const data = new FormData()
        data.append('service', serviceName.url_service_name)
        data.append('lang', this.currentLang)

        axios({
            method: 'post',
            url: '/sms_api/getTemplate.php?methods=getServiceTemplate',
            data
        }).then(function(response) {
            if (!response || !response.data.status || !response.data.hasOwnProperty('data')) {
                this.additionalTemplates = ''
                return false
            }
            this.additionalTemplates = response.data.data
        }.bind(this)).catch(function(err) {
            console.log(err)
            this.additionalTemplates = ''
        }.bind(this))
    },

    checkDropDownElements() {
        const infoBoxContent = document.querySelector('.info_box_content')
        if (!infoBoxContent) {
            return false
        }

        infoBoxContent.addEventListener('click', function(e) {
            const elClicked = e.target

            if (elClicked && elClicked.tagName == 'H5') {
                const dropDownContainer = elClicked.closest('div')
                if (dropDownContainer.classList.contains('info_about_service__drop_down_item')) {
                    dropDownContainer.classList.toggle('drop_down_item__open_desc')
                }
            }
        })
    },

    async getTopServicesByCountry(country) {
        this.topServicesByCountryLoaded = false
        if (this.currentCountry !== '') {
            if (country in this.topServicesByCountry) {
                this.topServicesByCountryLoaded = true
            } else {
                const data = new FormData()
                data.append('method', 'GET_TOP_SERVICES_BY_COUNTRY')
                data.append('country', country)
                axios({
                    method: 'post',
                    url: '/sms_api/orders.php?n=6-3',
                    data: data
                }).then(function(res) {
                    const data = res.data.response

                    if (res && res.data && res.data.hasOwnProperty('karma')) {
                        this.ratingToView = res.data.karma
                    }

                    if (data.res) {
                        this.topServicesByCountry[country] = data.data.splice(0, 12)
                        if (this.currentCountry === country) {
                            this.topServicesByCountryLoaded = true
                        }
                    }
                }.bind(this)).catch(function(err) {
                    console.log(err)
                })
            }
        }

        return this.topServicesByCountry[country]
    },

    async loadPricesByCountry(country, re = false) {
        this.pricesByCountryLoaded = re
        const priceCacheKey = this.getPriceCacheKey(country)
        const data = new FormData()
        data.append('method', 'GET_PRICES_BY_COUNTRY')
        data.append('country', country)

        if (this.typeNumbers && this.typesNumbers[this.typeNumbers]) {
            data.append('voice', this.typesNumbers[this.typeNumbers].voice)
        }

        axios({
            method: 'post',
            url: '/sms_api/orders.php?n=7-3',
            data: data
        }).then(function(res) {
            if (res.data.hasOwnProperty('karma')) {
                this.ratingToView = res.data.karma
            }

            const data = res.data.response

            if (data.res) {
                const temp = data.data
                temp.time = Date.now()
                this.pricesByCountry[priceCacheKey] = temp
                this.pricesByCountry[country] = temp
                this.pricesByCountryLoaded = true
            } else {
                this.notifyUser($L('ords.country_error'), 'error')
                this.currentCountry = ''
                this.amountByCountryLoaded = true
            }
        }.bind(this)).catch(function(err) {
            console.log(err)
        })
    },

    async getPricesByCountry(country, re = false) {
        this.pricesByCountryLoaded = re

        if (this.currentCountry !== '' && this.reverseMode) {
            const priceCacheKey = this.getPriceCacheKey(country)

            if (priceCacheKey in this.pricesByCountry) {
                this.pricesByCountry[country] = this.pricesByCountry[priceCacheKey]

                if (Date.now() - this.pricesByCountry[priceCacheKey].time > 60000) {
                    await this.loadPricesByCountry(country, re)
                } else if (this.currentCountry === country) {
                    this.pricesByCountryLoaded = true
                }
            } else {
                await this.loadPricesByCountry(country)
            }
        }
    },

    async loadPricesByService(service, re = false) {
        this.pricesByServiceLoaded = re
        const priceCacheKey = this.getPriceCacheKey(service)
        const data = new FormData()
        data.append('method', 'GET_PRICES_BY_SERVICE')
        data.append('service', service)

        if (this.typeNumbers && this.typesNumbers[this.typeNumbers]) {
            data.append('voice', this.typesNumbers[this.typeNumbers].voice)
        }

        axios({
            method: 'post',
            url: '/sms_api/orders.php?n=8-3',
            data: data
        }).then(function(res) {
            if (res.data.hasOwnProperty('karma')) {
                this.ratingToView = res.data.karma
            }

            const data = res.data.response

            if (data.res) {
                const temp = data.data
                temp.time = Date.now()
                this.pricesByService[priceCacheKey] = temp
                this.pricesByService[service] = temp
                if (this.currServOpt === service) {
                    this.pricesByServiceLoaded = true
                }
            } else {
                this.notifyUser($L('ords.service_error'), 'error')
                this.currServOpt = 'min'
                this.amountByServiceLoaded = true
            }
        }.bind(this)).catch(function(err) {
            console.log(err)
        })
    },

    async getPricesByService(service, re = false) {
        this.pricesByServiceLoaded = re
        if (this.currServOpt !== 'min' && !this.reverseMode) {
            const priceCacheKey = this.getPriceCacheKey(service)

            if (priceCacheKey in this.pricesByService) {
                this.pricesByService[service] = this.pricesByService[priceCacheKey]

                if (Date.now() - this.pricesByService[priceCacheKey].time > 60000) {
                    await this.loadPricesByService(service, re)
                } else if (this.currServOpt === service) {
                    this.pricesByServiceLoaded = true
                }
            } else {
                await this.loadPricesByService(service)
            }
        }
    },

    async loadAmountByCountry(country, re = false) {
        this.amountByCountryLoaded = re
        const data = new FormData()
        data.append('method', 'GET_AMOUNT_BY_COUNTRY')
        data.append('country', country)

        if (this.typeNumbers && this.typesNumbers[this.typeNumbers]) {
            data.append('voice', this.typesNumbers[this.typeNumbers].voice)
        }

        axios({
            method: 'post',
            url: '/sms_api/orders.php?n=9-3',
            data: data
        }).then(function(res) {
            if (res.data && res.data.karma) {
                this.ratingToView = res.data.karma
            }

            const data = res.data.response

            if (data.res) {
                const payload = data.data
                const temp = payload.amount || payload
                temp.time = Date.now()
                this.amountByCountry[country] = temp
                this.operatorRatingsByCountry[country] = payload.ratings || {}
                if (this.currentCountry === country) {
                    this.amountByCountryLoaded = true
                }
            } else {
                this.notifyUser($L('ords.country_error'), 'error')
                this.currentCountry = ''
                this.amountByCountryLoaded = true
            }
        }.bind(this)).catch(function(err) {
            console.log(err)
        })
    },

    async getAmountByCountry(country, re = false) {
        this.amountByCountryLoaded = re

        if (this.currentCountry !== '' && this.reverseMode) {
            if (country in this.amountByCountry) {
                if (Date.now() - this.amountByCountry[country].time > 30000) {
                    await this.loadAmountByCountry(country, re)
                } else if (this.currentCountry === country) {
                    this.amountByCountryLoaded = true
                }
            } else {
                await this.loadAmountByCountry(country)
            }
        }
    },

    async loadAmountByService(service, re = false) {
        this.amountByServiceLoaded = re
        const data = new FormData()
        data.append('method', 'GET_AMOUNT_AND_CONVERSATIONS_BY_SERVICE')
        data.append('service', service)

        if (this.typeNumbers && this.typesNumbers[this.typeNumbers]) {
            data.append('voice', this.typesNumbers[this.typeNumbers].voice)
        }

        axios({
            method: 'post',
            url: '/sms_api/orders.php?n=10-3',
            data: data
        }).then(function(res) {
            if (res.data.hasOwnProperty('karma')) {
                this.ratingToView = res.data.karma
            }

            const data = res.data.response

            if (data.res) {
                const payload = data.data
                let temp = payload.amount
                temp.time = Date.now()
                this.amountByService[service] = temp
                this.operatorRatingsByService[service] = payload.ratings || {}
                temp = payload.conversations
                temp.time = Date.now()
                this.conversationsByService[service] = temp
                if (this.currServOpt === service) {
                    this.amountByServiceLoaded = true
                }
            } else {
                this.notifyUser($L('ords.service_error'), 'error')
                this.currServOpt = 'min'
                this.amountByServiceLoaded = true
            }
        }.bind(this)).catch(function(err) {
            console.log(err)
        })
    },

    async getAmountByService(service, re = false) {
        this.amountByServiceLoaded = re
        if (this.currServOpt !== 'min' && !this.reverseMode) {
            if (service in this.amountByService) {
                if (Date.now() - this.amountByService[service].time > 30000) {
                    await this.loadAmountByService(service, re)
                } else if (this.currServOpt === service) {
                    this.amountByServiceLoaded = true
                }
            } else {
                await this.loadAmountByService(service)
            }
        }
    },

    async updateCurrentCombo() {
        if (this.currentCountry && this.reverseMode) {
            await this.getPricesByCountry(this.currentCountry, true)
            await this.getAmountByCountry(this.currentCountry, true)
            return
        }

        if (this.currServOpt && this.currServOpt !== 'min' && !this.reverseMode) {
            await this.getPricesByService(this.currServOpt, true)
            await this.getAmountByService(this.currServOpt, true)
        }
    },
}
